import {TimelineTimeAxisScaleType} from 'vis-timeline/esnext';
import {unitOfTime} from 'moment';

interface TimelineViewSettings {
    timerEnabled: boolean;
    scale: TimelineTimeAxisScaleType;
    extendedView: boolean;
}

/**
 * General utilties for the timeline computation
 */
class TimelineUtils {

    /**
     * Saves the current settings in local storage
     */
    saveSettings(uniqueStoreKey: string, viewSettings: TimelineViewSettings) {
        window.localStorage.setItem(uniqueStoreKey, JSON.stringify({
            timer: viewSettings.timerEnabled,
            scale: viewSettings.scale,
            extendedView: viewSettings.extendedView
        }));
    }

    /**
     * Saves the saved settings from local storage
     */
    restoreSettings(uniqueStoreKey: string): TimelineViewSettings {
        const result: TimelineViewSettings = {
            timerEnabled: false,
            scale: 'day',
            extendedView: false
        };
        const savedValueRaw: any = window.localStorage.getItem(uniqueStoreKey);
        if (savedValueRaw) {
            try {
                const savedValue = JSON.parse(savedValueRaw);
                result.timerEnabled = savedValue.timer;
                result.scale = savedValue.scale;
                result.extendedView = savedValue.extendedView;
            } catch (error) {
                alert(error);
            }
        }
        return result;
    }

    /**
     * TimelineTimeAxisScaleType to moment.js unitOfTime.Diff transformer
     */
    transformScaleToUnitOfTime(scale: TimelineTimeAxisScaleType) {
        let result: unitOfTime.Diff;
        switch (scale) {
            case 'month':
                result = 'month';
                break;
            case 'day':
                result = 'day';
                break;
            case 'hour':
                result = 'hour';
                break;
            case 'millisecond':
                result = 'millisecond';
                break;
            case 'minute':
                result = 'minute';
                break;
            case 'second':
                result = 'second';
                break;
            case 'weekday':
            // @ts-ignore
            case 'week':
                result = 'week';
                break;
            case 'year':
                result = 'year';
                break;
            default:
                result = 'month';
                break;
        }
        return result;
    }

}

const TIMELINE_UTILS_INSTANCE = new TimelineUtils();

export {TIMELINE_UTILS_INSTANCE, TimelineViewSettings};
